import React from "react";
import Carousel from "react-bootstrap/Carousel";
import "./Carousel.css";

import Card1 from "../Images/Caurosel/SNV Group Photo.jpg";
import Card2 from "../Images/Caurosel/Team Training.jpg";
import Card3 from "../Images/Caurosel/Training for Co2Balance.jpg";
import Card4 from "../Images/Caurosel/Charcoal Chunning (4).jpg";
import Card5 from "../Images/Caurosel/Charcoal Chunning (11).jpg";
import Card6 from "../Images/Caurosel/Stove Warming.jpg";
import Card7 from "../Images/Caurosel/MEMD Training (2).jpg";
import Card8 from "../Images/Caurosel/Training for the o2Balance (2).jpg";
import Card9 from "../Images/Caurosel/HIVOS Team.jpg";
import Card10 from "../Images/Caurosel/Dutch Spark Team.jpg";
import Card11 from "../Images/Caurosel/BSUL Verification Meeting.jpg";
import Card12 from "../Images/Caurosel/IMEU Expo Team.jpg";
import Card13 from "../Images/Caurosel/IMG20240306120928.jpg";
import Card14 from "../Images/Caurosel/IMG20240325153442.jpg";
import Card15 from "../Images/Caurosel/IMG20230705141314.jpg";
import Card16 from "../Images/Caurosel/IMG20220630104947.jpg";
import Card17 from "../Images/Caurosel/IMG20230705114602.jpg";
import Card18 from "../Images/Caurosel/IMG20230518122333.jpg";
import Card19 from "../Images/Caurosel/IMG20230509112112.jpg";

/* ─── Slide data ─────────────────────────────────────────── */
const SLIDES = [
  {
    img: Card14,
    alt: "CIRCODU Staff with CLASP Representatives",
    title:
      "CIRCODU Staff and the Cookstove Laboratory Team with CLASP Representatives",
    caption:
      "Representatives from CLASP on a visit to our Cookstove Laboratory to discuss possibilities for technical and financial support, March 2024.",
  },
  {
    img: Card13,
    alt: "SEI CIRCODU Focus Group Discussion",
    title: "SEI CIRCODU Focus Group Discussion",
    caption:
      "A Stockholm Environment Institute (SEI) Team in collaboration with the CIRCODU Team conducting a Focus Group Discussion with different players in the Uganda Cooking Sector, at Ministry of Energy and Mineral Development, March 2024.",
  },
  {
    img: Card15,
    alt: "National eCooking Strategy Stakeholders Workshop",
    title: "National eCooking Strategy Stakeholders Workshop",
    caption:
      "CIRCODU Team with Ministry of Energy and Mineral Development / Modern Energy Cooking Services (MECS) Team and stakeholders during a meeting on the progress of the National eCooking Strategy, at Esella Country Hotel, July 2023.",
  },
  {
    img: Card16,
    alt: "IMEU Validation Stakeholders Workshop",
    title: "IMEU Validation Stakeholders Workshop",
    caption:
      "CIRCODU Director General, Mr. Joseph Ndemere Arineitwe during the Stakeholders presentation of the IMEU Baseline and Market Assessment report at Silver Springs, Bugoloobi, August 2022.",
  },
  {
    img: Card17,
    alt: "National eCooking Strategy Workshop",
    title: "National eCooking Strategy Stakeholders Workshop",
    caption:
      "CIRCODU Team with MEMD / MECS Team and stakeholders during a meeting on the progress of the National eCooking Strategy, at Esella Country Hotel, July 2023.",
  },
  {
    img: Card18,
    alt: "Data Cleaning Exercise",
    title: "Data Cleaning Exercise",
    caption:
      "Data Cleaning Exercise at the Office Premises with Teams that participated in the eCooking Baseline Study to Assess the Status Quo for eCooking in Uganda, May 2023.",
  },
  {
    img: Card19,
    alt: "Training of Research Assistants",
    title: "Training of Research Assistants",
    caption:
      "Training of Research Assistants for the eCooking Baseline Study to Assess the Status Quo for eCooking in Uganda, May 2023.",
  },
  {
    img: Card1,
    alt: "IMEU Validation Stakeholders Workshop — Group Photo",
    title: "IMEU Validation Stakeholders Workshop",
    caption:
      "CIRCODU Team with Stakeholders after the presentation of the IMEU Baseline and Market Assessment report at Silver Springs, Bugoloobi, August 2022.",
  },
  {
    img: Card2,
    alt: "eCooking Baseline Study — Field Research Training",
    title: "Training of Field Research Assistants",
    caption:
      "During the training of Research Assistants for the National eCooking Baseline Study and Strategy development in Uganda, February 2023.",
  },
  {
    img: Card3,
    alt: "Training for Co2Balance",
    title: "Training of Field Research Assistants",
    caption:
      "During the training of Research Assistants for the Baseline Study for the Dutch Spark for Clean Cooking Solutions on Pre-Project Fuel Consumption Patterns in Uganda, October 2022.",
  },
  {
    img: Card4,
    alt: "Laboratory Team sorting charcoal",
    title: "Charcoal Sorting",
    caption:
      "Laboratory Team sorting charcoal to be used in the cookstove testing process.",
  },
  {
    img: Card5,
    alt: "Laboratory Team sorting charcoal",
    title: "Charcoal Sorting",
    caption:
      "Laboratory Team sorting charcoal to be used in the cookstove testing process.",
  },
  {
    img: Card6,
    alt: "Laboratory Team warming up cookstoves",
    title: "Cookstove Warming",
    caption:
      "Laboratory Team warming up cookstoves during the cookstove testing process.",
  },
  {
    img: Card7,
    alt: "Clean Cooking Energy Needs Assessment Training",
    title: "Training of Field Research Assistants",
    caption:
      "Staff during the Training on activities under the Ministry of Energy and Mineral Development / World Bank consultancy: Conducting Clean Cooking Energy Needs Assessment in Public and Private Institutions in Uganda, August 2022.",
  },
  {
    img: Card8,
    alt: "Training of Field Research Assistants",
    title: "Training of Field Research Assistants",
    caption:
      "During the training of Research Assistants for the Baseline Study for the Dutch Spark for Clean Cooking Solutions, October 2022.",
  },
  {
    img: Card9,
    alt: "HIVOS Team",
    title: "CIRCODU Team",
    caption:
      "During the training of Research Assistants for the Baseline Study for the Dutch Spark for Clean Cooking Solutions, October 2022.",
  },
  {
    img: Card10,
    alt: "Dutch Spark Team",
    title: "CIRCODU Team",
    caption:
      "CIRCODU Team that participated in the UpEnergy Baseline Study and Kitchen Performance Tests in Schools across Four Administrative Regions in Uganda, June 2022.",
  },
  {
    img: Card11,
    alt: "Biogas Solutions Uganda Limited Verification Exercise",
    title: "Biogas Solutions Uganda Limited Verification Exercise",
    caption:
      "With a Team of verifiers from Biogas Solutions Uganda Limited / African Biogas Carbon Programme during a spot check Verification Exercise.",
  },
  {
    img: Card12,
    alt: "IMEU EXPO CIRCODU TEAM",
    title: "IMEU EXPO CIRCODU Team",
    caption:
      "CIRCODU Team that represented at the SNV IMEU Regional Energy Efficiency Awareness Expo (22nd–26th March 2023) in Fort Portal.",
  },
];

/* ─── Component ──────────────────────────────────────────── */
function Carousels() {
  return (
    <div className="carous">
      <Carousel fade interval={8000} indicators={true}>
        {SLIDES.map((slide, index) => (
          <Carousel.Item key={index}>
            <img
              className="imageC"
              src={slide.img}
              alt={slide.alt}
              /*
               * First slide: load immediately and signal this is the
               * page's LCP element so the browser prioritises it.
               * All other slides: defer until the browser is idle.
               */
              loading={index === 0 ? "eager" : "lazy"}
              fetchpriority={index === 0 ? "high" : "low"}
              /* Explicit dimensions stop layout shift (fixes CLS score) */
              width="1200"
              height="800"
            />
            <Carousel.Caption>
              <h5>
                <b>{slide.title}</b>
              </h5>
              <p>{slide.caption}</p>
            </Carousel.Caption>
          </Carousel.Item>
        ))}
      </Carousel>
    </div>
  );
}

export default Carousels;
